<template>
    <section id="coverpage">
        <div class="coverpage-main">
            <div class="coverpage-bg-blur fade-in"></div>
            <div class="coverpage-content fade-in">
                <img class="main-logo" src="../assets/img/Logo.png" alt="" />

                <template v-if="totalSupply !== null && maxSupply !== null">
                    <small style="color:white; opacity: 0.4">Minted {{ totalSupply }} of {{ maxSupply }}</small>
                </template>
                <template v-if="!cHasEthProvider">
                    <a href="https://metamask.io/download/" target="_blank" class="btn-mint" style="font-size: 0.7em">Install Metamask</a>
                </template>
                <template v-else>
                    <template v-if="cHasTokensAvailableToMint">
                        <template v-if="currentWallet !== null">
                            <div v-if="isOnMintingProcess">
                                <span class="btn-mint" style="font-size: 0.7em">Waiting for you to confirm</span>
                            </div>
                            <button v-else @click="mintNFT()" class="btn-mint">MINT</button>
                        </template>
                    </template>

                    <TransactionInfo v-if="mintTransactionHash" :transactionHash="mintTransactionHash" />
                    <WalletDataBlock @walletUpdated="currentWallet = $event" />
                </template>

                <a href="#aboutus" class="btn-to-go-down">
                    <img src="../assets/img/flechas.png" alt="" />
                </a>
            </div>
        </div>
    </section>
</template>
<script>
import axios from "axios";
import WalletDataBlock from "./CoverPage/WalletDataBlock.vue";
import TransactionInfo from "./TransactionInfo/TransactionInfo.vue";

export default {
    data() {
        return {
            currentWallet: null,
            balance: null,
            contractAddress: null,
            maxSupply: null,
            totalSupply: null,
            isOnMintingProcess: false,
            mintTransactionHash: null
        };
    },

    components: { WalletDataBlock, TransactionInfo },
    computed: {
        cHasEthProvider() {
            return typeof window.ethereum !== "undefined";
        },

        cHasTokensAvailableToMint() {
            const noNullSupply = this.totalSupply !== null && this.maxSupply !== null;
            const hasAvailableTokens = this.totalSupply < this.maxSupply;

            return noNullSupply && hasAvailableTokens;
        }
    },

    async created() {
        const maxSupplyResponse = await axios.get("api/maxSupply");
        const maxSupply = maxSupplyResponse.data?.maxSupply ?? null;
        if (maxSupply !== null) {
            this.maxSupply = Number(maxSupply);
        }

        const totalSupplyResponse = await axios.get("api/totalSupply");
        const totalSupply = totalSupplyResponse.data?.totalSupply ?? null;
        if (totalSupply !== null) {
            this.totalSupply = Number(totalSupply);
        }
    },

    methods: {
        async mintNFT() {
            try {
                if (typeof window.ethereum !== "undefined") {
                    this.isOnMintingProcess = true;
                    const mintDataResponse = await axios.get(`api/mintData?wallet=${this.currentWallet}`);
                    const contractAddress = mintDataResponse.data.contractAddress ?? null;
                    const walletAddress = mintDataResponse.data.walletAddress ?? null;
                    const weiValue = mintDataResponse.data.weiValue ?? null;
                    const encodedContractData = mintDataResponse.data.encodedContractData ?? null;

                    if (
                        contractAddress === null ||
                        walletAddress === null ||
                        weiValue === null ||
                        encodedContractData === null
                    ) {
                        throw Error("Can't get information to interact whith 'smart contract'");
                    }

                    const transactionParameters = {
                        from: walletAddress,
                        to: contractAddress,
                        value: weiValue,
                        data: encodedContractData
                    };

                    const txHash = await window.ethereum.request({
                        method: "eth_sendTransaction",
                        params: [transactionParameters]
                    });

                    if (txHash) {
                        this.mintTransactionHash = txHash;
                    }

                    this.isOnMintingProcess = false;
                }
            } catch (error) {
                console.error(error?.message ?? "There was an error on minting process");
                this.isOnMintingProcess = false;
            }
        }
    }
};
</script>
